<template>
  <div>
<!--    <form class="needs-validation" @submit.prevent="submitCreateUnitModel">-->
    <form class="needs-validation">

      <div class="row form-group">
        <p>{{ question }}</p>
      </div>

      <div class="form-group">
        <label for="selected_legal_person">Поиск держателя</label>
        <br>
        <input class="form-control form-control-sm"
               type="text" id="selected_legal_person"  v-model="searchQuery" placeholder="Поиск..."
        />
      </div>

      <div v-if="isLoading" class="row" :key="'loading_units_content'">
        <div class="offset-5 spinner-border text-primary" role="status">
          <span class="visually-hidden"></span>
          <!--                          <span class="visually-hidden">Загрузка...</span>-->
        </div>
      </div>
      <table v-else class="col-12 table table-hover" style="cursor: pointer;">

        <thead>
        <tr class="row">
          <th class="col-1">ID</th>
          <th class="col-11">Название</th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="item in filteredList" :key="item.id" class="row table-info" @click="selectHolder(item)">
          <td class="col-1">{{item.id}}</td>
          <td class="col-11">{{item.title}}</td>
        </tr>
        </tbody>

      </table>

    </form>
  </div>

</template>

<script>

import axios from "axios";

export default {
  // mixins: [validationMixin],
  name: "HolderSelector",
  data() {
    return {
      searchQuery: '',
      question: null,
      isLoading: true,
      holdersData: [
          {
            id: null,
            title: "",
          }
      ],
      submitted: false,
    }
  },
  mounted() {
  },
  props: {
  },
  watch: {
  },
  computed: {
    filteredList() {
      return this.holdersData.filter(item => item.title.toLowerCase().includes(this.searchQuery.toLowerCase()));
    }
  },
  validations: {
    modelData: {
    },
  },
  methods: {
    selectHolder(holder) {
      this.$emit('event-holder-selected', holder);
    },
    /**
     * получаем актуальный список холдеров (обычных не технических)
     */
    getHoldersData() {
      let uri = `/v1/unit-holders/get-all-simple`;
      axios
          .get(uri)
          .then(resp => {
            this.holdersData = resp.data;
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          }).finally(resp => {
        this.isLoading = false;
      })
      ;
    },
    showHolders() {
      if (this.holdersData[0].id === null) {
        this.isLoading = true;
      }
      this.getHoldersData();
      this.hasPartnersWithoutHolders();
    },

    /**
     * Факт наличия партнеров, не являющихся держателями
     */
    hasPartnersWithoutHolders() {
      let uri = `/v1/unit-holders/get-partners-without-holders-count`;
      axios
          .get(uri)
          .then(resp => {
            let count = resp.data;
            if (count > 0) {
              if (confirm("Найдены новые партнеры ("+ count + " шт.) Импортировать их в справочник держателей?")) {
                this.importNewPartners();
              }
            }
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          }).finally(resp => {
        this.isLoading = false;
      })
      ;
    },

    /**
     * Импортирует новых партнеров в держателей
     */
    importNewPartners() {
      this.isLoading = true;
      axios
          .post(`/v1/unit-holders/import-new-partners-to-holders`)
          .then(resp => {
            if (resp.data > 0) {
              this.getHoldersData();
            }
          })
          .catch(err => {
            this.$store.dispatch("addNotification", {
              text: err.response.data.message,
              time: 6,
              color: "danger"
            });
          }).finally(resp => {
            this.isLoading = false;
      })
      ;
    }
  },
  created() {

  }
};
</script>

<style scoped lang="css">

</style>
